module.exports = __webpack_public_path__ + "img/xmark-to-slot-duotone.946c41a4.svg";